import type { Capability } from './capability';

export type { Capability } from './capability';
export { resolveCapability, SHOW_GRANTS, GLOBAL_GRANTS, isGlobalCapability } from './capability';
export type { ShowActor } from './showActor';
export { actorForShow, assignmentFor, isStaffRole, isStudentRole } from './showActor';
export { canModerateAuthoredContent, STAFF_AUTHOR_ROLES } from './contentModeration';
export { useShowPermissions, useCan } from './useCan';
export type { ShowPermissions } from './useCan';

/**
 * The show Settings sections the caller can act on. Settings is a staff area:
 * plain students and student leaders hold none of these, so the tab is hidden
 * for them outright. (Leaders had show details and Recently Deleted until
 * October 2026.)
 *
 * Recently Deleted is manageShow rather than deleteShowResource: a leader may
 * still delete a library file, but listing, restoring and purging the trash
 * is staff-only (assertCanManageLibrary in recently-deleted.ts).
 */
export function visibleSettingsSections(can: (capability: Capability) => boolean) {
  const sections = {
    showDetails: can('editShowDetails'),
    rehearsalSettings: can('manageRehearsals'),
    appearance: can('manageShow'),
    gallery: can('manageShow'),
    privacy: can('manageShow'),
    recentlyDeleted: can('manageShow'),
    advanced: can('manageShow'),
  };
  return { ...sections, any: Object.values(sections).some(Boolean) };
}
